"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findGroupByType = void 0;
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
function findGroupByType(groupBys, fieldType) {
    return groupBys.find(gb => QueryFieldRegistry_1.default[gb.queryFieldKey].fieldType === fieldType);
}
exports.findGroupByType = findGroupByType;
exports.default = findGroupByType;
